var App = App || {};

App.ComponentTeams = (($) => {
    'use strict';

    const selectors = {
        component: '.teams',
        row: '.team-row',
        card: '.team-card',
        subtitle: '.leadership-team-subtitle',
        emptyMsg: '.teams-empty-message',
        dropdown: '.teams-dropdown'
    };

    const cleanText = (str) => (str || '').replace(/\s+/g, ' ').trim();

    const getEmailFromCard = ($teamsCard) => {
        const $mailtoEl = $teamsCard.find('a[href^="mailto:"]').first();
        return $mailtoEl.length ? $mailtoEl.attr('href').trim() : null;
    };

    const buildAriaLabel = ($teamsCard, mailto) => {
        const name  = cleanText($teamsCard.find('.teams-card-title').text());
        const desc  = cleanText($teamsCard.find('.teams-card-desc').text());
        const email = mailto ? mailto.replace('mailto:', '').trim() : '';
        const phone = cleanText($teamsCard.find('.teams-card-contact span').text());
        return [name, desc, email, phone].filter(Boolean).join('. ');
    };

    const initCard = ($card) => {
        const $teamsCard = $card.find('.teams-card');

        // Remove any previous role=button behavior
        $teamsCard.removeAttr('role tabindex aria-label');
        $teamsCard.off('click keydown');

        // Upgrade phone spans to tel: links
        $teamsCard.find('.teams-card-contact span').each((_, el) => {
            const $span = $(el);
            const phone = $span.text().trim();
            if (phone && !$span.closest('a').length) {
                const digits = phone.replace(/\D/g, '');
                $span.replaceWith(`<a href="tel:${digits}">${phone}</a>`);
            }
        });

        // Wrap the name in a mailto: link if not already linked
        const $title = $teamsCard.find('.teams-card-title');
        if ($title.length && !$title.find('a').length) {
            const $mailtoEl = $teamsCard.find('a[href^="mailto:"]').first();
            if ($mailtoEl.length) {
                const href = $mailtoEl.attr('href');
                const name = $title.text().trim();
                $title.html(`<a href="${href}">${name}</a>`);
            }
        }

        // Restore mailto links to normal (undo pointer-events:none / aria-hidden)
        $teamsCard.find('a[href^="mailto:"]').each((_, el) => {
            const $a = $(el);
            $a.removeAttr('tabindex aria-hidden').css('pointer-events', '');
        });
    };

    const initCards = ($component) => {
        $component.find(selectors.card).each((_, el) => {
            initCard($(el));
        });
    };

    const alignSubtitle = ($component) => {
        const $row      = $component.find(selectors.row);
        const $cards    = $row.find(`${selectors.card}:visible`);
        const $subtitle = $component.find(selectors.subtitle);

        if (!$cards.length) {
            return $subtitle.css('padding-left', 0);
        }

        const offset = $cards.first().offset().left - $row.offset().left;
        $subtitle.css('padding-left', offset);
    };

    const toggleEmptyState = ($component) => {
        const visibleCount = $component.find(`${selectors.card}:visible`).length;
        const $subtitle = $component.find(selectors.subtitle);
        const $emptyMsg = $component.find(selectors.emptyMsg);

        if (visibleCount === 0) {
            $subtitle.attr('aria-hidden', 'true').hide();
            $emptyMsg
                .removeClass('visually-hidden')
                .text('No team members found for the selected category.');
        } else {
            $subtitle.removeAttr('aria-hidden').show();
            $emptyMsg
                .addClass('visually-hidden')
                .text('');
        }
    };

    const updateSubtitle = ($component, text) => {
        $component.find(selectors.subtitle).text(`${text} Team`);
    };

    const filterCards = ($component, selectedValue) => {
        $component.find(selectors.card).each((_, el) => {
            const $card    = $(el);
            const cardData = ($card.attr('team-data') || '').split(',');
            const show     = selectedValue === 'Select' || cardData.includes(selectedValue);
            $card.toggle(show);
        });
    };

    const focusFirstCard = ($component) => {
        const $firstCard = $component.find(`${selectors.card}:visible .teams-card`).first();
        if ($firstCard.length) {
            $firstCard.focus();
        }
    };

    const handleDropdownChange = function () {
        const $dropdown    = $(this);
        const $component   = $dropdown.closest(selectors.component);
        const selectedValue = $dropdown.val();
        const selectedText  = $dropdown.find('option:selected').text();
        const defaultText   = $dropdown.find('option').eq(1).text();

        updateSubtitle(
            $component,
            selectedValue === 'Select' ? defaultText : selectedText
        );

        filterCards($component, selectedValue);
        focusFirstCard($component);
        toggleEmptyState($component);
        alignSubtitle($component);
    };

    const init = () => {
        $(selectors.component).each((_, el) => {
            const $component = $(el);

            initCards($component);

            $component.find(selectors.subtitle)
                .attr('aria-live', 'polite')
                .attr('aria-atomic', 'true');

            $component.find(selectors.emptyMsg)                
                .css('display', '')
                .text('');

            const $dropdown = $component.find(selectors.dropdown);
            if ($dropdown.length) {
                $dropdown.on('change', handleDropdownChange);
            }

            setTimeout(() => {
                toggleEmptyState($component);
                alignSubtitle($component);
            }, 50);
        });

        $(window).on('resize', () => {
            $(selectors.component).each((_, el) => {
                alignSubtitle($(el));
            });
        });
    };

    return { init };

})(jQuery);

$(App.ComponentTeams.init);
